import ImpressionDivWrapper from '@/components/Common/ImpressionDivWrapper';
import { NolPromotionStoreCtx } from '@/stores/NolPromotionStore';
import { observer } from 'mobx-react-lite';
import React, { useContext } from 'react';

import styles from './index.module.scss';
import InterparkEventCard from './InterparkEventCard';

const CardEvent = () => {
  const store = useContext(NolPromotionStoreCtx);

  return (
    <ImpressionDivWrapper
      logData={{
        pageName: store.pageName,
        objectContainer: '해외여행·공연·오프라인 혜택까지 NOL 카드 이벤트',
        motherPageVersion: store.version,
        motherPageSectionType: '이벤트',
        motherPageSectionName: '해외여행·공연·오프라인 혜택까지 NOL 카드 이벤트',
      }}
    >
      {/*content에 anchor가 걸리는데, padding 만큼 올리기 위한 의도로 위에 ref 를 받는 div 추가.*/}
      <div className={styles.eventContainer}>
        <div className={styles.title}>
          NOL 전용
          <br />
          NOL 카드 추가 혜택
        </div>
        <div className={styles.descriptions}>
          <div className={styles.chip}>NOL 카드 추가 혜택 </div>
          <span className={styles.target}>
            대상: NOL 카드 보유 회원 <br />
            (본인 회원 기준)
          </span>
        </div>
        <div className={styles.cardsContainer}>
          <InterparkEventCard />
        </div>
      </div>
    </ImpressionDivWrapper>
  );
};

export default observer(CardEvent);
